import axios from "axios";

export default {
  namespaced: true,
  state: {
    pricelist: require("@/assets/files/pricelist.pdf"),
  },
  getters: {
    pricelist(state) {
      return state.pricelist;
    },
  },
  mutations: {
    setPriceList(state, payload) {
      state.pricelist = payload;
    },
  },
  actions: {
    getPriceList(store, payload) {
      const url = "https://api.sk-grant.kz/api/v1/get-file";

      axios
        .get(url)
        .then(response => {
          let resp = response.data;
          //console.log(resp);
          if (resp.file) {
            store.commit("setPriceList", resp.file);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
